import { render, staticRenderFns } from "./ApiLink.vue?vue&type=template&id=62129643&scoped=true&"
import script from "./ApiLink.vue?vue&type=script&lang=js&"
export * from "./ApiLink.vue?vue&type=script&lang=js&"
import style0 from "./ApiLink.vue?vue&type=style&index=0&id=62129643&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62129643",
  null
  
)

export default component.exports